import { ArticleFields } from '@pressreader/content-types';
import { error } from '@pressreader/logger';
import { httpGet } from '@pressreader/services';

import { IArticleDto } from '../types';

interface GetArticlesRequest {
    articleIds: string[];
    fields: ArticleFields;
    lang?: string | null;
    isHyphenated?: boolean;
}

/**
 * @returns - A list of articles or nulls in case an article was not found for the respective article ID.
 */
function getArticles(request: GetArticlesRequest): Promise<(IArticleDto | null)[]> {
    if (!request.articleIds || request.articleIds.length === 0) {
        error('No article IDs provided for getArticles request');
        return Promise.resolve([]);
    }

    const data: { ids: string; articleFields: ArticleFields; lang?: string; isHyphenated?: boolean } = {
        ids: request.articleIds.join(','),
        articleFields: request.fields,
    };

    if (request.lang) {
        data.lang = request.lang;
    }

    data.isHyphenated = request.isHyphenated === undefined ? true : request.isHyphenated;

    return httpGet<(IArticleDto | null)[]>('v1/articles', '', data);
}

export { getArticles };
